<template>
    <div id="fundAuthManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:8px" class="hewidth">
                <el-select v-model="searchForm.orderState" placeholder="请选择预授权状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.account" placeholder="请输入账号" ></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
 
            <el-form-item style="width: 30% margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit">查询</el-button>
                <!-- <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button> -->
                 <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <!-- <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i> -->
            </el-form-item>
        </el-form>
        <el-col>
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        prop="outOrderNo"
                        align="center"
                        width="200"                       
                        label="订单号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="authNo"
                        width="250"
                        label="授权订单号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="name"
                        width="150"
                        label="姓名">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="account"
                        width="200"
                        label="账号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        width="150"
                        label="手机号码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="amount"
                        label="押金">
                    </el-table-column>
                    <el-table-column
                    align="center"
                    width="160"
                    prop="createTime"
                    sortable
                    label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | date}} </span>
                    </template>
                </el-table-column>
                 <el-table-column
                align="center"
                prop="paymentAmount"
                width="100"
                label="支付金额">
                <template slot-scope="scope" >
                  <el-input type="number" size="small" v-model="scope.row.paymentAmount" :disabled="scope.row.orderState != '2'"></el-input>
                </template>
            </el-table-column>
             <el-table-column
                align="center"
                prop="memo"
                width="150"
                label="支付备注">
                <template slot-scope="scope" >
                  <el-input  size="small" v-model="scope.row.memo" :disabled="scope.row.orderState != '2'"></el-input>
                </template>
            </el-table-column>
                <el-table-column
                    align="center"
                    label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.orderState == '1'">待冻结</span>
                        <span v-if="scope.row.orderState == '2'">已冻结</span>
                        <span v-if="scope.row.orderState == '3'">已解冻</span>
                        <span v-if="scope.row.orderState == '4'">扣款并解冻</span>
                    </template>
                </el-table-column>
                    <el-table-column
                        align="center"
                        prop="refundReason"
                        width="200"
                        label="操作" v-if="basicsAuth.ensure">
                        <template slot-scope="scope">
                            <span  v-if="scope.row.orderState == '1'" >用户待确认</span>
                            
                            <span class="active-status" v-if="scope.row.orderState == '2'" @click="overOrder(scope.row)">解冻订单</span>

                            <span class="active-status" v-if="scope.row.orderState == '2'" @click="tradePay(scope.row)">扣款并解冻</span>
                            <span  v-if="scope.row.orderState == '3'" >解冻成功</span>
                            <span  v-if="scope.row.orderState == '4'" >扣款解冻成功</span>
                            <!-- <span class="active-status" v-if="scope.row.orderState == '3'" @click="confirmBtn(scope.row)">解冻详情</span>
                            <span class="active-status" v-if="scope.row.orderState == '4'" @click="confirmBtn(scope.row)">扣款详情</span> -->
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50,100,200,500,1000,5000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>

    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match';
    import {needCLodop,getLodop} from '@/util/LodopFuncs'
    import { fundAuthListList,finishOrder,confirmEnsure,orderUnfreeze,tradePay } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'fundAuthManage',
        data () {
            return {
                pickingStatusList:[
                    {
                        paraName:'待冻结',
                        paraCode:'1'
                    },
                    {
                        paraName:'已冻结',
                        paraCode:'2'
                    },
                     {
                        paraName:'已解冻',
                        paraCode:'3'
                    },
                    {
                        paraName:'支付并解冻',
                        paraCode:'4'
                    }
                ],
                engineersList:[],
                copy:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                // searchForm:{
                //     type:"1",
                //     qrCode:'',  //二维码编号
                //     status:'',  //入库状态
                //     orderSn:'',  //关联订单号
                //     fetchPerson:'',
                //     phone:'',
                //     attribute1:'',
                //     attribute2:'',
                // },
                  searchForm:{
                     name:'',  //姓名
                     orderState:'',  //状态
                     account:'',  //M3账号
                     phone:'',//手机号
                 },
                modelForm:{
                    id:'',
                    orderId:'',
                    maintenance_status:"1"
                },
                returnData: [],
                codeList:[],
                valueTime1:[],
                basicsAuth:{
                    ensure:false,
                    create_code:false
                }
            }
        },
        created(){
            this.basicsAuth.ensure = getPermission('/api/shopInventory/ensure');
            this.basicsAuth.create_code = getPermission('/api/shopInventory/create_code');
             
            this.getfundAuthListList();
            //this.getEngineerList();
        },
        methods: {
            //强制刷新
            changeFetchPerson(e){
                console.log(e);
                this.searchForm.fetchPerson = e;
                this.$forceUpdate();
            },
            // changeAmount(row){

            //     row.paymentAmount = row.paymentAmount;
            // },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.fetchPerson = val;
                    this.engineersList = result;
                }else{
                    this.engineersList = this.copy;
                    this.searchForm.fetchPerson = "";
                }
            },
            confirmBtn(row){
                this.modelForm.id = row.id;
                this.modelForm.orderId = row.orderId;
                let message = '是否确认收到该设备？';
                this.$confirm(message, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.submitConfirmModel()
                }).catch(action => {
                    
                });
            },
            //结束订单
            overOrder(row){
                console.log(row)
                if(!row.outOrderNo || !row.outRequestNo){
                    return
                }
                orderUnfreeze({authNo:row.authNo,outRequestNo:row.outOrderNo,amount:row.amount}).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getfundAuthListList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },

            //支付转解冻
            tradePay(row){
                console.log(row)
                if(!row.outOrderNo || !row.outRequestNo){
                    return
                }
                tradePay({authNo:row.authNo,outTradeNo:row.outOrderNo,totalAmount:row.paymentAmount,memo:row.memo}).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getfundAuthListList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //确认收到
            submitConfirmModel(){
                confirmEnsure(this.modelForm).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.getfundAuthListList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.type="1"
                this.getfundAuthListList();
            },
            //获取退款申请管理列表
            getfundAuthListList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                fundAuthListList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
           
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getfundAuthListList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getfundAuthListList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索取机记录
            onSubmit() {
                  if(this.valueTime1 != null && this.valueTime1.length > 1 ){
                    this.searchForm.attribute1 = new Date(this.valueTime1[0])
                    this.searchForm.attribute2 = new Date(this.valueTime1[1])
                }else{
                    this.searchForm.attribute1 = "";
                    this.searchForm.attribute2 = "";
                }
                this.getfundAuthListList()
                // this.$refs[this.searchForm].validate((valid) => {
                //     if (valid) {
                        
                //     } else {
                //         return false;
                //     }
                // });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #fundAuthManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-status{
            color:#409EFF;
            cursor:pointer
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }
     .hewidth {
        width: 13% !important;
      }

</style>



// WEBPACK FOOTER //
// fundAuthManage.vue?6216ad69